import React, { Component } from 'react';
import PropTypes from "prop-types";

export default class ButtonGroup extends Component {
    static propTypes = {
        /**
         * make buttons horizontal positioned
         */
        horizontal: PropTypes.bool,
        /**
         * make button centered
         */
        centered: PropTypes.bool,
        /**
         * add additional class to wrapper
         */
        additionalClass: PropTypes.string,
        /**
         *  Component inner (can be anything)
         */
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node
        ]).isRequired
    };

    constructor(props) {
        super(props);

        this.getClassNames = this.getClassNames.bind(this);
    }

    getClassNames() {
        const classNames = ['button-group'];

        const {horizontal, centered, additionalClass, className} = this.props;

        if(horizontal) {
            classNames.push('button-group--horizontal');
        }
        if(centered) {
            classNames.push('justify-content-center');
        }
        if(additionalClass) {
            classNames.push(additionalClass)
        }
        if(className) {
            classNames.push(className)
        }

        return classNames
    }

    render() {
        const {...rest} = this.props;
        const reservedOptionNames = ['className','horizontal', 'centered', 'additionalClass'];
        const classNames = this.getClassNames().join(' ');

        const restOptions = {};

        for (const [key, value] of Object.entries(rest)) {
            if(!reservedOptionNames.includes(key)) {
                restOptions[key] = value;
            }
        }

        return (
            <div className={classNames} {...restOptions}>
                {this.props.children}
            </div>
        )
    }
}
